<template>
  <div class="section-wrapper">
    <section>
      <div v-for="step in steps" :key="step.id" class="wrapper">
        <Steps
          :description="step.description"
          :title="step.title"
          :image="step.image"
          :step="step.step"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Steps from "~/components/global/Steps";

export default {
  components: {
    Steps
  },
  data: function() {
    return {
      steps: [
        {
          step: "Step 1",
          title: "Test and assess yourself",
          description:
            "Measure yourself regularly with Workera’s adaptive skills assessments. Track your progress and inform your personalized learning plan.",
          image: require("~/assets/img/landing-page/steps/consumer1.png"),
          id: "1"
        },
        {
          step: "Step 2",
          title: "Benchmark yourself against the best-in-class",
          description:
            "Drive your personal learning by comparing your data-AI skills against top talent at organizations including Facebook, Google, Amazon and Stanford University. Know where you stand against the best.",
          image: require("~/assets/img/landing-page/steps/consumer2.png"),
          id: "2"
        },
        {
          step: "Step 3",
          title: "Improve with a progressive learning plan",
          description:
            "Unlock your potential with a personalized learning plan that grows with you. Continue to test, assess, and progress as you develop increasingly sophisticated skills. Incorporate your accomplishments into your daily workflow and professional brand.",
          image: require("~/assets/img/landing-page/steps/consumer3.png"),
          id: "3"
        }
      ]
    };
  },

  computed: {
    containerClass() {
      switch (this.$mq) {
        case "desktop":
          return "skills-boost column--duo--equivalent";
        default:
          return "skills-boost single";
      }
    },
    title() {
      switch (this.$mq) {
        case "desktop":
          return "title";
        default:
          return "title-mobile";
      }
    },
    step() {
      switch (this.$mq) {
        case "desktop":
          return " ";
        default:
          return "title-mobile";
      }
    },
    description() {
      switch (this.$mq) {
        case "desktop":
          return "descrpt";
        default:
          return "description-mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
%wrapper {
}
.section-wrapper {
  background: #f7f9fc;
}
</style>
